import React from 'react'
import { getTenantInfoByKey, isoToDate, parseMillisecondsToHoursAndMinutes } from '../../../../helpers/helpers';

const PermanenceTableDetailList = ({ detail }) => {

  const haveAccessOpenings = getTenantInfoByKey('is_access_opening')
  const haveBuildings = getTenantInfoByKey('is_building')

  const [dateIn, timeIn] = isoToDate(detail.dateIn).split('T');

  const [dateOut, timeOut] = isoToDate(detail.dateOut).split('T');

  return (
    <tr className='text-center'>
      {haveAccessOpenings && (
        <td className='custom-border blue-dark-text'>
          {detail.opening ? detail.opening : '-'}
        </td>
      )}
      {haveBuildings && (
        <td className='custom-border blue-dark-text'>
          {detail.building ? detail.building : '-'}
        </td>
      )}
      <td className='custom-border blue-dark-text'>
        <span>
          {dateIn} <strong>{timeIn.slice(0, 5)}</strong>
        </span>
      </td>
      <td className='custom-border blue-dark-text'>
        {detail.userIn ? detail.userIn : '-'}
      </td>
      <td className='custom-border blue-dark-text'>
        <span>
          {dateOut} <strong>{timeOut.slice(0, 5)}</strong>
        </span>
      </td>
      <td className='custom-border blue-dark-text'>
        {detail.userOut ? detail.userOut : '-'}
      </td>
      <td className='custom-border blue-dark-text'>
        {detail.hs_norm ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(detail.hs_norm).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(detail.hs_norm).split(':')[1])}min</strong>) : '-'}
      </td>
      <td className='custom-border blue-dark-text'>
        {detail.hs_50 ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(detail.hs_50).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(detail.hs_50).split(':')[1])}min</strong>) : '-'}
      </td>
      <td className='blue-dark-text'>
        {detail.hs_100 ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(detail.hs_100).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(detail.hs_100).split(':')[1])}min</strong>) : '-'}
      </td>
    </tr>
  )
}

export default PermanenceTableDetailList